var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSyncedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 8.08299C6.08352 8.4179 6.40313 8.69501 6.77016 8.89554C7.13719 9.09606 7.54305 9.21531 7.96022 9.24518C8.37739 9.27506 8.7961 9.21487 9.18796 9.06869C9.57982 8.92252 9.93566 8.69378 10.2313 8.39799L11.9813 6.64799C12.5126 6.0979 12.8066 5.36114 12.8 4.5964C12.7933 3.83166 12.4866 3.10012 11.9458 2.55935C11.405 2.01858 10.6735 1.71183 9.90876 1.70519C9.14402 1.69854 8.40727 1.99253 7.85718 2.52382L6.85384 3.52132",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16629 6.91574C7.91578 6.58083 7.59617 6.30372 7.22914 6.10319C6.86211 5.90267 6.45625 5.78342 6.03908 5.75355C5.62191 5.72367 5.2032 5.78386 4.81134 5.93003C4.41948 6.07621 4.06364 6.30495 3.76796 6.60074L2.01796 8.35074C1.48667 8.90083 1.19268 9.63759 1.19933 10.4023C1.20597 11.1671 1.51272 11.8986 2.05349 12.4394C2.59426 12.9802 3.3258 13.2869 4.09054 13.2935C4.85528 13.3002 5.59204 13.0062 6.14213 12.4749L7.13963 11.4774",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncedIcon);
export default __webpack_public_path__ + "static/media/syncedIcon.381471f2db3ff084d905d99ff97f2328.svg";
export { ForwardRef as ReactComponent };